import React from 'react';
import { useViewport } from 'react-viewport-provider';
import { IssuersListLG } from './IssuersList.lg';

export interface IProps {
    onSearchClick?(): void;
    onCardClick?(eventKey?: string): void;
    drawerWidth: number;
    onInviteIssuer?(formData?:any):void,
    issuersList?:any;
    inviteUserLoading?:boolean;
    inviteUserStaus?:boolean;
    getUsersLoading?:boolean;
}

export const IssuersList = (props: IProps) => {
    const { bp } = useViewport();

    // if (bp === 'xs' || bp === 'sm') {
    //     return <DashboardSM />;
    // }

    // if (bp === 'md') {
    //   return <DashboardMD />;
    // }

    //bp === 'lg' || bp === 'xl' || bp === 'md
    return <IssuersListLG {...props} />;
};
